module.exports = __webpack_public_path__ + "static/media/customer-service-code.7327eb6c.png";